<template>
    <div>
      <patentBulletinAnalyseReport-list></patentBulletinAnalyseReport-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  